import { Reveal, Eyebrow } from "./Reveal";
import { useLang } from "../../i18n";

const stats = [
  { v: "70%", l: "gr.stat1" },
  { v: "100%", l: "gr.stat2" },
];

export const Grades = () => {
  const { t } = useLang();
  return (
    <section data-testid="grades-section" className="bg-[#29221D] text-[#F3EFE6] py-24 lg:py-40 grain-dark">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-12 lg:px-20">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <Reveal><Eyebrow light>{t("gr.eyebrow")}</Eyebrow></Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-6 font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
                {t("gr.h2a")} <em className="text-[#C18A53]">{t("gr.h2em")}</em> {t("gr.h2b")}
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2} className="lg:col-span-5 flex items-end">
            <p className="text-base md:text-lg text-[#D6CFC4] leading-relaxed">{t("gr.p")}</p>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <div data-testid="grade-a" className="mt-20 grid lg:grid-cols-12 gap-8 lg:gap-14 items-stretch">
            <div className="lg:col-span-7 relative overflow-hidden group min-h-[320px] lg:min-h-[520px]">
              <img
                src="/img/grade-a.jpg"
                alt="Capi in cashmere selezionati, prima scelta"
                loading="lazy"
                decoding="async"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1C1917]/80 via-transparent to-transparent" />
              <span className="absolute top-6 left-6 font-serif text-[6rem] lg:text-[8rem] leading-none text-[#F3EFE6]/30 group-hover:text-[#C18A53] transition-colors duration-700">A</span>
            </div>
            <div className="lg:col-span-5 flex flex-col justify-center">
              <span className="font-mono text-xs uppercase tracking-[0.25em] text-[#C18A53]">{t("gr.label")}</span>
              <h3 className="mt-4 font-serif font-light text-4xl lg:text-5xl leading-tight">{t("gr.title")}</h3>
              <p className="mt-5 text-base md:text-lg text-[#D6CFC4] leading-relaxed">{t("gr.p1")}</p>
              <p className="mt-4 text-sm md:text-base text-[#D6CFC4]/80 leading-relaxed">{t("gr.p2")}</p>
              <a href="#contatti" data-testid="grades-cta" className="btn-pill mt-8 border border-[#C18A53] text-[#C18A53] hover:!bg-[#C18A53] hover:!text-[#29221D] w-fit">
                {t("gr.cta")}
              </a>
            </div>
          </div>
        </Reveal>

        <div className="mt-20 grid sm:grid-cols-2 gap-10">
          {stats.map((s, i) => (
            <Reveal key={s.l} delay={0.1 * i}>
              <div data-testid={`grade-stat-${i}`} className="flex items-baseline gap-6 border-t border-[#C18A53] pt-6">
                <span className="font-serif text-6xl lg:text-8xl font-light">{s.v}</span>
                <span className="font-mono text-xs uppercase tracking-[0.2em] text-[#E2C9A6]">{t(s.l)}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
